export const DEFAULT_LANG = 'zh-TW';

const en = {
  appName: 'AITTS Service',
  appTagline: 'Lecture STT · Turn recordings into notes',
  navChat: 'Chat',
  navTts: 'TTS',
  navStt: 'STT',
  navUpload: 'Upload',
  navStatus: 'Status',
  navFaq: 'FAQ',
  navPricing: 'Pricing',
  authChecking: 'Checking session',
  authSignedIn: 'Signed in',
  authGuest: 'Guest mode',
  signInWithGoogle: 'Sign in with Google',
  signOut: 'Sign out',
  signedInAs: 'Signed in as',

  // Upload page (EN)
  uploadTitle: 'Lecture STT · AI-Powered Notes',
  uploadSubtitle:
    'Upload your lecture recording to generate a transcript and optional AI summary.',
  uploadFormatsHint:
    'Accepted formats: .webm, .m4a, .mp3, .wav (max duration depends on your plan)',
  uploadSelectFile: 'Lecture audio file',
  uploadSelectedFile: 'Selected file',
  uploadLectureTitle: 'Lecture title',
  uploadLectureTitlePlaceholder: 'Week 3 - Revenue Recognition',
  uploadSubject: 'Subject / course',
  uploadSubjectPlaceholder: 'Accounting 101',
  uploadTags: 'Tags',
  uploadTagsPlaceholder: 'IFRS, revenue',
  uploadLocaleLabel: 'Language',
  language_auto_detect: 'Auto detect language',
  language_manual: 'Manual select',
  language_en_general: 'English (All)',
  language_en_india: 'English (India)',
  language_zh_cn: 'Chinese (China)',
  language_zh_tw: 'Chinese (Taiwan)',
  language_yue_hk: 'Cantonese (Hong Kong)',
  uploadTaskLabel: 'Output',
  uploadTaskTranscriptOnly: 'Transcript only',
  uploadTaskTranscriptSummary: 'Transcript + summary (recommended)',
  uploadButton: 'Upload & Start Processing',
  uploadUploading: 'Uploading...',
  uploadSignInToUpload: 'Sign in to upload',
  uploadDisabledHint:
    'Please sign in with Google to start processing your lecture.',
  uploadSignInPrompt:
    'Please sign in with Google to start processing. You can still fill the details below.',
  errorSignInRequired:
    'Please sign in with Google to start processing your lecture.',
  errorFileRequired: 'Please select an audio file to upload.',
  errorUploadFailed: 'Failed to upload lecture',
  uploadStatusHint:
    'After uploading, you can check progress anytime on the Status page using your Lecture ID.',
  tipsTitle: 'Tips for best results',
  tipsItem1: 'Use clear audio with minimal background noise.',
  tipsItem2:
    'Adding the lecture title and subject helps the AI generate better summaries.',
  tipsItem3: 'Choose transcript only if you do not need an AI summary.',
  uploadSuccessTitle: 'Lecture uploaded!',
  uploadRequestIdLabel: 'Request ID',
  uploadLectureIdLabel: 'Lecture ID',
  uploadViewStatus: 'View status',

  statusPageTitle: 'Lecture Status',
  statusSubtitle:
    'Enter your lecture ID to check transcript and summary progress.',
  statusPleaseSignIn:
    'Please sign in with Google to check your lecture status.',
  statusEnterId: 'Please enter a Lecture ID or request ID.',
  statusEnterLectureId: 'Please enter a Lecture ID.',
  statusCheckButton: 'Check status',
  statusChecking: 'Checking...',
  statusRefreshButton: 'Refresh status',
  statusRefreshing: 'Refreshing...',
  statusInputPlaceholder: 'Lecture ID (e.g. L2025-11-25-001)',
  statusEmptyState:
    'Paste your lecture ID to view progress. You can find it on the upload success screen or in your emails.',

  metaLectureTitle: 'Lecture title',
  metaSubject: 'Subject',
  metaTags: 'Tags',
  metaLocale: 'Locale',

  downloadTranscript: 'Download transcript',

  statusSummaryTitle: 'AI summary',
  summaryTldr: 'TL;DR',
  summaryKeyPoints: 'Key points',
  summaryExamples: 'Examples',
  summaryHomework: 'Homework',

  statusProcessing: 'Processing',
  statusProcessingNote:
    'We are still transcribing and summarising your lecture. Please click refresh later to get the latest updates.',
  statusDone: 'Completed',
  statusFailed: 'Failed',
  statusFailedGeneric:
    'Processing failed. Try uploading again with a clearer audio file.',

  loadingSession: 'Loading your session...',
  notAvailable: 'N/A',

  footerCopyright: '© 2025 AITTS Service',
  footerLinksFaq: 'FAQ',
  footerLinksTerms: 'Terms of Service',
  footerLinksPrivacy: 'Privacy Policy',
  footerLinksContact: 'Contact',
  footerFindUs: 'Find us on',
  footerFacebook: 'Facebook',
  footerKofi: 'Ko-fi',

  faqTitle: 'FAQ',
  faqSubtitle: 'We will add detailed Lecture Notes FAQs soon.',
  faqComingSoon:
    'FAQ content coming soon. We will cover supported formats, processing time, language support, and privacy.',

  pricingTitle: 'Pricing',
  pricingSubtitle: 'We will add pricing details and plan comparison soon.',
  pricingComingSoon: 'Pricing plans will be added here later.',
  pricingPlanFree: 'Free',
  pricingPlanStudent: 'Student',
  pricingPlanPro: 'Pro (coming soon)',

  quickStatus: 'Go to status',
  quickPricing: 'View pricing',
  quickFaq: 'FAQ',

  status_pending: 'Pending',
  status_processing: 'Processing',
  status_completed: 'Completed',
  status_failed: 'Failed',
  status_unknown: 'N/A',

  lecture_upload_title: 'Lecture STT · AI-Powered Notes',
  lecture_upload_subtitle:
    'Upload your lecture recording to generate a transcript and optional AI summary.',
  lecture_history_title: 'My lecture history (last 10)',
  lecture_history_hint:
    'Select a lecture below to load its latest status.',
  lecture_history_empty:
    'No records yet. Upload a lecture to see it here.',
  lecture_history_loading: 'Loading...',
  lecture_history_error:
    'Unable to load your lecture history. Please try again later.',
  lecture_history_signin:
    'Please sign in to view your lecture history.',

  lecture_advanced_label:
    'Advanced: enter lecture ID to search directly',
  lecture_check_status_button: 'Check status',
  lecture_refresh_button: 'Refresh status',
  lecture_download_button: 'Download transcript',
  lecture_view_button: 'View',
  lecture_copy_button: 'Copy',
  lecture_id_label: 'Lecture ID',
  lecture_title_label: 'Title',
  lecture_status_label: 'Status',
  lecture_updated_label: 'Last updated',
  lecture_action_label: 'Action',
  lecture_ai_summary_title: 'AI summary',
  lecture_ai_keypoints_title: 'Key points',
  lecture_language_label: 'Language',
  lecture_tags_label: 'Tags',

  upload_success_headline: 'Lecture uploaded and processing',
  upload_success_subtitle:
    'Your recording is being processed. You can check progress on the status page.',
  upload_lecture_id_row_label: 'Lecture ID (use this to check status)',
  upload_copy_id: 'Copy',

  download_no_lecture_selected: 'Please select a lecture first.',
  download_not_ready:
    'Transcript is not ready yet or failed to generate. Please try again later.',
  download_no_url:
    'Transcript link is not available yet. Please refresh status.',
  download_error_generic:
    'Unable to download transcript. Please try again later.',
  download_transcript_button: 'Download transcript',
  lecture_transcript_not_ready: 'Transcript is not ready yet.',
  lecture_transcript_download_failed:
    'Failed to download transcript. Please try again.',
  status_friendly_error:
    'Processing failed. Please try again later or re-upload.',
  status_show_details: 'Show technical details',
  status_hide_details: 'Hide technical details',
  copy_success: 'Copied to clipboard',

  // STT inline strings (EN)
  sttStep1Title: 'Step 1 — Record your lecture',
  sttStep1Description:
    'Use our free Chrome extension to record your lecture or online class (e.g., Zoom, Google Meet, LMS playback).',
  sttOpenRecorderButton: 'Open Recorder',
  sttOpenRecorderHint:
    'You need to install the Chrome extension before using the recorder.',
  sttStep2Title: 'Step 2 — Upload your recording',
  sttExtensionBannerTitle: 'Recording ready to upload',
  sttExtensionBannerDescription:
    'Your recording {{filename}} is now saved on your device.',
  sttExtensionBannerInstruction:
    'Please click “Select File” below and choose this file to start transcription.',
  sttExtensionBannerModePrefix: 'Capture mode:',
  sttModeTab: 'Browser tab audio',
  sttModeMic: 'Microphone recording',
  sttPreviewHint:
    'Preview is limited to the first 15 seconds. The full recording will be uploaded when you submit.',

  // STT nested block (EN)
  stt: {
    step1Title: 'Step 1 — Record your lecture',
    step1Description:
      'Use our free Chrome extension to record your lecture or online class (e.g., Zoom, Google Meet, LMS playback).',
    openRecorderButton: 'Open Recorder',
    openRecorderHint:
      'You need to install the Chrome extension before using the recorder.',
    step2Title: 'Step 2 — Upload your recording',
    extensionBannerTitle: 'Recording ready to upload',
    extensionBannerDescription:
      'Your recording {{filename}} is now saved on your device.',
    extensionBannerInstruction:
      'Please click “Select File” below and choose this file to start transcription.',
    extensionBannerModePrefix: 'Capture mode:',
    modeTab: 'Browser tab audio',
    modeMic: 'Microphone recording',
    previewHint:
      'Preview is limited to the first 15 seconds. The full recording will be uploaded when you submit.',
  },
};

const zhTW = {
  ...en,

  // Upload page overrides (ZH-TW)
  uploadTitle: '課堂語音轉文字・AI 課堂筆記',
  uploadSubtitle: '上載課堂錄音，系統會自動產生逐字稿與 AI 摘要。',
  uploadFormatsHint:
    '支援 .webm、.m4a、.mp3、.wav（可處理長度依方案而定）',
  uploadSelectFile: '課堂錄音檔案',
  uploadSelectedFile: '已選擇檔案',
  uploadLectureTitle: '課堂主題',
  uploadSubject: '科目／課程名稱',
  uploadTags: '標籤（可選，逗號分隔）',
  uploadLocaleLabel: '語言',
  language_auto: '自動偵測',
  language_manual: '手動選擇',
  language_en_general: '英文（一般口音）',
  language_en_india: '英文（印度）',
  language_zh_cn: '普通話（簡體）',
  language_zh_tw: '國語（繁體）',
  language_yue_hk: '粵語（香港）',
  uploadTaskLabel: '處理內容',
  uploadTaskTranscriptSummary: '逐字稿 + AI 摘要（建議）',
  uploadTaskTranscriptOnly: '只要逐字稿',
  uploadStatusHint:
    '上載後，你可以隨時到「狀態頁面」輸入 Lecture ID 查看處理進度。',
  uploadButton: '上載並開始處理',
  uploadUploading: '正在上載，請稍候…',
  errorFileRequired: '請先選擇一個錄音檔案。',
  errorUploadFailed: '上載失敗，請稍後再試。',

  tipsTitle: '最佳效果小貼士',
  tipsItem1: '請使用清晰錄音並減少背景噪音。',
  tipsItem2: '填寫課堂主題與科目可讓 AI 生成更準確的摘要。',
  tipsItem3: '若只需要逐字稿，可選擇「只要逐字稿」。',

  upload_success_headline: '上載成功！',
  upload_success_subtitle: '我們已收到你的課堂錄音，AI 正在處理中。',
  uploadRequestIdLabel: '處理編號',
  upload_lecture_id_row_label: '課堂 ID',
  upload_copy_id: '複製 ID',
  uploadViewStatus: '前往狀態查詢',

  // STT phrases (ZH-TW)
  sttStep1Title: '步驟一 — 錄製課堂語音',
  sttStep1Description:
    '使用我們的免費 Chrome 擴充功能錄製課堂或線上課程（例如 Zoom、Google Meet、LMS 課程影片）。',
  sttOpenRecorderButton: '開啟錄音工具',
  sttOpenRecorderHint: '使用前需先安裝 Chrome 擴充功能。',
  sttStep2Title: '步驟二 — 上載錄音檔',
  sttExtensionBannerTitle: '錄音已準備好上載',
  sttExtensionBannerDescription:
    '您的錄音 {{filename}} 已下載至您的裝置。',
  sttExtensionBannerInstruction:
    '請點選下方「選擇檔案」，並選擇此錄音檔開始轉文字。',
  sttExtensionBannerModePrefix: '錄音模式：',
  sttModeTab: '瀏覽器分頁錄音',
  sttModeMic: '麥克風錄音',
  sttPreviewHint: '預覽僅限前 15 秒，提交後會上載完整錄音檔。',

  language_auto_detect: '自動偵測語言',
  quickStatus: '查看狀態',
  quickPricing: '查看收費',
  quickFaq: '常見問題',
  authGuest: '訪客模式',
  uploadLectureTitlePlaceholder: '第 3 週 - 收入確認',
  uploadSubjectPlaceholder: '會計學 101',
  uploadTagsPlaceholder: 'IFRS、收入',

  navUpload: '上載',
  navStatus: '狀態',
  navFaq: '常見問題',
  navPricing: '收費',
  signInWithGoogle: '使用 Google 登入',
  signOut: '登出',
  signedInAs: '目前登入：',
  authSignedIn: '已登入',

  statusPageTitle: '課堂處理狀態',
  statusSubtitle: '輸入課堂 ID 以查看逐字稿與 AI 摘要的處理進度。',
  statusPleaseSignIn: '請先使用 Google 登入以查看課堂狀態。',
  statusEnterId: '請輸入課堂 ID 或請求 ID。',
  statusEnterLectureId: '請輸入課堂 ID。',
  statusCheckButton: '查詢狀態',
  statusChecking: '查詢中…',
  statusRefreshButton: '重新整理狀態',
  statusRefreshing: '重新整理中…',
  statusInputPlaceholder: '課堂 ID（例如：L2025-11-25-001）',
  statusEmptyState:
    '請輸入課堂 ID 以查看進度。你可在上載成功畫面或電郵中找到該 ID。',

  status_pending: '等待中',
  status_processing: '處理中',
  status_completed: '完成',
  status_failed: '失敗',
  status_unknown: '未知',

  metaLectureTitle: '課堂主題',
  metaSubject: '科目',
  metaLocale: '語言',
  metaTags: '標籤',

  lecture_history_title: '我的課堂記錄（最近 10 筆）',
  lecture_history_hint: '點選下方課堂即可查看最新狀態。',
  lecture_history_empty:
    '暫無記錄。上載課堂後，可在此查看記錄。',
  lecture_history_loading: '載入中…',
  lecture_history_error:
    '無法載入課堂記錄，請稍後再試。',
  lecture_history_signin:
    '請先登入以查看你的課堂記錄。',

  lecture_id_label: '課堂 ID',
  lecture_title_label: '主題',
  lecture_status_label: '狀態',
  lecture_updated_label: '最後更新',
  lecture_action_label: '操作',
  lecture_view_button: '查看',
  lecture_copy_button: '複製',
  lecture_check_status_button: '查詢狀態',
  lecture_refresh_button: '重新整理',
  lecture_download_button: '下載逐字稿',

  statusProcessing: '處理中',
  statusProcessingNote:
    '我們仍在進行語音轉文字與摘要產生，請稍後點選重新整理以取得最新進度。',
  statusDone: '已完成',
  statusFailed: '處理失敗',
  statusFailedGeneric:
    '處理失敗，請嘗試使用更清晰的錄音重新上載。',

  status_friendly_error:
    '處理失敗，請稍後再試或嘗試重新上載。',
  status_show_details: '顯示技術細節',
  status_hide_details: '隱藏技術細節',

  summaryTldr: '重點摘要',
  summaryKeyPoints: '重點整理',
  summaryExamples: '課堂例子',
  summaryHomework: '課後練習',

  lecture_ai_summary_title: 'AI 課堂摘要',

  downloadTranscript: '下載逐字稿',
  download_no_lecture_selected: '請先選擇一個課堂。',
  download_not_ready:
    '逐字稿尚未準備好，或處理失敗。請稍後再試。',
  download_no_url:
    '逐字稿連結尚未產生，請重新整理狀態。',
  download_error_generic:
    '無法下載逐字稿，請稍後再試。',

  copy_success: '已複製至剪貼簿',

  loadingSession: '正在載入使用者資訊…',
  notAvailable: 'N/A',

  stt: {
    step1Title: '步驟一 — 錄製課堂語音',
    step1Description:
      '使用我們的免費 Chrome 擴充功能錄製課堂或線上課程（例如 Zoom、Google Meet、LMS 課程影片）。',
    openRecorderButton: '開啟錄音工具',
    openRecorderHint: '使用前需先安裝 Chrome 擴充功能。',
    step2Title: '步驟二 — 上載錄音檔',
    extensionBannerTitle: '錄音已準備好上載',
    extensionBannerDescription:
      '您的錄音 {{filename}} 已下載至您的裝置。',
    extensionBannerInstruction:
      '請點選下方「選擇檔案」，並選擇此錄音檔開始轉文字。',
    extensionBannerModePrefix: '錄音模式：',
    modeTab: '瀏覽器分頁錄音',
    modeMic: '麥克風錄音',
    previewHint: '預覽僅限前 15 秒，提交後會上載完整錄音檔。',
  },
};

const zhCN = {
  ...en,

  // Upload page overrides (ZH-CN)
  uploadTitle: '课堂语音转文字 · AI 课堂笔记',
  uploadSubtitle: '上传课堂录音，系统会自动生成逐字稿和 AI 摘要。',
  uploadFormatsHint:
    '支持 .webm、.m4a、.mp3、.wav（可处理时长视方案而定）',
  uploadSelectFile: '课堂录音文件',
  uploadSelectedFile: '已选择文件',
  uploadLectureTitle: '课堂主题',
  uploadSubject: '科目／课程名称',
  uploadTags: '标签（可选，逗号分隔）',
  uploadLocaleLabel: '语言',
  language_auto: '自动检测',
  language_manual: '手动选择',
  language_en_general: '英语（通用口音）',
  language_en_india: '英语（印度）',
  language_zh_cn: '普通话（简体）',
  language_zh_tw: '国语（繁体）',
  language_yue_hk: '粤语（香港）',
  uploadTaskLabel: '处理内容',
  uploadTaskTranscriptSummary: '逐字稿 + AI 摘要（推荐）',
  uploadTaskTranscriptOnly: '仅要逐字稿',
  uploadStatusHint:
    '上传后，你可以随时前往「状态页面」，输入 Lecture ID 查看处理进度。',
  uploadButton: '上传并开始处理',
  uploadUploading: '正在上传，请稍候…',
  errorFileRequired: '请先选择一个录音文件。',
  errorUploadFailed: '上传失败，请稍后再试。',

  tipsTitle: '最佳效果小贴士',
  tipsItem1: '请尽量使用清晰录音并减少背景噪音。',
  tipsItem2:
    '填写课堂主题和科目有助于 AI 生成更准确的摘要内容。',
  tipsItem3: '如果只需要逐字稿，可以选择「仅要逐字稿」。',

  upload_success_headline: '上传成功！',
  upload_success_subtitle: '我们已收到你的课堂录音，AI 正在处理中。',
  uploadRequestIdLabel: '处理编号',
  upload_lecture_id_row_label: '课堂 ID',
  upload_copy_id: '复制 ID',
  uploadViewStatus: '前往状态查询',

  // STT phrases (ZH-CN)
  sttStep1Title: '步骤一 — 录制课堂语音',
  sttStep1Description:
    '使用我们的免费 Chrome 扩展录制课堂或线上课程（如 Zoom、Google Meet、LMS 课程视频）。',
  sttOpenRecorderButton: '开启录音工具',
  sttOpenRecorderHint: '使用前需安装 Chrome 扩展。',
  sttStep2Title: '步骤二 — 上传录音文件',
  sttExtensionBannerTitle: '录音已准备好上传',
  sttExtensionBannerDescription:
    '您的录音 {{filename}} 已保存到您的设备。',
  sttExtensionBannerInstruction:
    '请点击下方「选择文件」，并选择此录音文件开始转写。',
  sttExtensionBannerModePrefix: '录音模式：',
  sttModeTab: '浏览器标签页录音',
  sttModeMic: '麦克风录音',
  sttPreviewHint: '预览仅限前 15 秒，提交后会上传完整录音文件。',

  language_auto_detect: '自动检测语言',
  quickStatus: '查看状态',
  quickPricing: '查看收费',
  quickFaq: '常见问题',
  authGuest: '访客模式',
  uploadLectureTitlePlaceholder: '第 3 周 - 收入确认',
  uploadSubjectPlaceholder: '会计学 101',
  uploadTagsPlaceholder: 'IFRS、收入',

  navUpload: '上传',
  navStatus: '状态',
  navFaq: '常见问题',
  navPricing: '收费',
  signInWithGoogle: '使用 Google 登录',
  signOut: '退出登录',
  signedInAs: '当前登录：',
  authSignedIn: '已登录',

  statusPageTitle: '课堂处理状态',
  statusSubtitle: '输入课堂 ID 查看逐字稿与 AI 摘要的处理进度。',
  statusPleaseSignIn: '请先使用 Google 登录以查看课堂状态。',
  statusEnterId: '请输入课堂 ID 或请求 ID。',
  statusEnterLectureId: '请输入课堂 ID。',
  statusCheckButton: '查询状态',
  statusChecking: '查询中…',
  statusRefreshButton: '刷新状态',
  statusRefreshing: '刷新中…',
  statusInputPlaceholder: '课堂 ID（例如：L2025-11-25-001）',
  statusEmptyState:
    '请输入课堂 ID 查看处理进度。你可以在上传成功页面或邮件中找到该 ID。',

  status_pending: '等待中',
  status_processing: '处理中',
  status_completed: '已完成',
  status_failed: '失败',
  status_unknown: '未知',

  metaLectureTitle: '课堂主题',
  metaSubject: '科目',
  metaLocale: '语言',
  metaTags: '标签',

  lecture_history_title: '我的课堂记录（最近 10 条）',
  lecture_history_hint: '点击下面的课堂即可查看最新状态。',
  lecture_history_empty:
    '暂无记录。上传课堂后，你可以在此查看。',
  lecture_history_loading: '加载中…',
  lecture_history_error:
    '无法加载课堂记录，请稍后再试。',
  lecture_history_signin:
    '请先登录以查看你的课堂记录。',

  lecture_id_label: '课堂 ID',
  lecture_title_label: '主题',
  lecture_status_label: '状态',
  lecture_updated_label: '最后更新',
  lecture_action_label: '操作',
  lecture_view_button: '查看',
  lecture_copy_button: '复制',
  lecture_check_status_button: '查询状态',
  lecture_refresh_button: '刷新',
  lecture_download_button: '下载逐字稿',

  statusProcessing: '处理中',
  statusProcessingNote:
    '系统正在进行转写与摘要生成，请稍后点击刷新以查看最新进度。',
  statusDone: '已完成',
  statusFailed: '处理失败',
  statusFailedGeneric:
    '处理失败，请尝试使用更清晰的录音重新上传。',

  status_friendly_error:
    '处理失败，请稍后再试或重新上传。',
  status_show_details: '显示技术详情',
  status_hide_details: '隐藏技术详情',

  summaryTldr: '重点摘要',
  summaryKeyPoints: '重点整理',
  summaryExamples: '课堂示例',
  summaryHomework: '课后练习',

  lecture_ai_summary_title: 'AI 课堂摘要',

  downloadTranscript: '下载逐字稿',
  download_no_lecture_selected: '请先选择一个课堂。',
  download_not_ready:
    '逐字稿尚未就绪或处理失败，请稍后再试。',
  download_no_url:
    '逐字稿链接尚未生成，请刷新状态。',
  download_error_generic:
    '无法下载逐字稿，请稍后再试。',

  copy_success: '已复制到剪贴板',

  loadingSession: '正在加载用户信息…',
  notAvailable: 'N/A',

  stt: {
    step1Title: '步骤一 — 录制课堂语音',
    step1Description:
      '使用我们的免费 Chrome 扩展录制课堂或线上课程（如 Zoom、Google Meet、LMS 课程视频）。',
    openRecorderButton: '开启录音工具',
    openRecorderHint: '使用前需安装 Chrome 扩展。',
    step2Title: '步骤二 — 上传录音文件',
    extensionBannerTitle: '录音已准备好上传',
    extensionBannerDescription:
      '您的录音 {{filename}} 已保存到您的设备。',
    extensionBannerInstruction:
      '请点击下方「选择文件」，并选择此录音文件开始转写。',
    extensionBannerModePrefix: '录音模式：',
    modeTab: '浏览器标签页录音',
    modeMic: '麦克风录音',
    previewHint: '预览仅限前 15 秒，提交后会上传完整录音文件。',
  },
};

export const translations = {
  en,
  'zh-TW': zhTW,
  'zh-CN': zhCN,
};
